import type { WorkType } from '../../shared/types';
import { WORK_TYPE_STYLE } from '../lib/format';

export function WorkTypeBadge({ type }: { type: WorkType }) {
  const style = WORK_TYPE_STYLE[type] ?? WORK_TYPE_STYLE.Other;
  return (
    <span
      className="inline-block rounded-[var(--radius-pill)] px-2.5 py-[3px] text-[11px] font-semibold whitespace-nowrap"
      style={{ background: style.bg, color: style.fg }}
    >
      {type}
    </span>
  );
}
